import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  supplier_name: "",
  batch_code: "",
  date: "",
  paid_status: "",
};

const RejectedLogFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    supplier_name: filters.supplier_name || "",
    batch_code: filters.batch_code || "",
    date: filters.date || "",
    paid_status: filters.paid_status || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({
      supplier_name: filters.supplier_name || "",
      batch_code: filters.batch_code || "",
      date: filters.date || "",
      paid_status: filters.paid_status || "",
    });
  }, [filters.supplier_name, filters.batch_code, filters.date, filters.paid_status]);

  const status = [
    { label: _t("PAID", "PAID"), value: "paid" },
    { label: _t("UNPAID", "UNPAID"), value: "unpaid" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltersData({ ...filtersData, [name]: value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

        <InputWithLabel
          label={_t("supplier_name", "Supplier Name")}
          type="text"
          name="supplier_name"
          value={filtersData.supplier_name}
          onChange={handleChange}
        />

        <InputWithLabel
          label={_t("batch_code", "Batch Code")}
          type="text"
          name="batch_code"
          value={filtersData.batch_code}
          onChange={handleChange}
        />

        <InputWithLabel
          label={_t("unloading_date", "Unloading Date")}
          type="date"
          name="date"
          value={filtersData.date}
          onChange={handleChange}
        />

        <SelectBox
          label={_t("status", "status")}
          name="paid_status"
          value={filtersData.paid_status}
          onChange={handleChange}
          options={status?.map((list) => ({
            value: list.value,
            label: _t(list.label, list.label),
          }))}
        />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default RejectedLogFilter;
